import { fetchWrapper } from "../utils/fetch-wrapper";




const societesMeresService = {
    getAll,
    getById,
    post,
    delete: _delete,
};


function getAll() {
    return fetchWrapper.get("societes_meres/");
  }
  
  function getById(id) {
    return fetchWrapper.get(`societes_meres/${id}`);
  }
  
  function post(data) {
    return fetchWrapper.post("societes_meres/", data);
  }
  
  function update(id, params) {
    return fetchWrapper.put(`societes_meres/${id}`, params);
  }
  
  function _delete(id) {
    return fetchWrapper.delete(`societes_meres/${id}`);
  }
  


export default societesMeresService;